module.exports = __webpack_public_path__ + "img/b9b5a7c8a7b71aeecdb11c510b004d6.f065c354.jpg";